import { render, staticRenderFns } from "./AreaChart.vue?vue&type=template&id=7905fcda&scoped=true&"
import script from "./AreaChart.vue?vue&type=script&lang=js&"
export * from "./AreaChart.vue?vue&type=script&lang=js&"
import style0 from "./AreaChart.vue?vue&type=style&index=0&id=7905fcda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7905fcda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7905fcda')) {
      api.createRecord('7905fcda', component.options)
    } else {
      api.reload('7905fcda', component.options)
    }
    module.hot.accept("./AreaChart.vue?vue&type=template&id=7905fcda&scoped=true&", function () {
      api.rerender('7905fcda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/monitoring/widgets/AreaChart.vue"
export default component.exports